module.exports = __webpack_public_path__ + "static/media/pvgateway.a5dbacec.jpg";